import { createFileRoute } from "@tanstack/react-router";
import { LegalPageLayout } from "@/components/legal-page-layout";
import { COMPANY, formatAddress } from "@/lib/company-info";

export const Route = createFileRoute("/yasal/on-bilgilendirme")({
  head: () => ({
    meta: [
      { title: "Ön Bilgilendirme Formu — JUËN" },
      { name: "description", content: "Mesafeli sözleşme öncesi tüketici ön bilgilendirme formu." },
      { property: "og:title", content: "Ön Bilgilendirme Formu — JUËN" },
      { property: "og:description", content: "Mesafeli sözleşme öncesi tüketici ön bilgilendirme formu." },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <LegalPageLayout title="Ön Bilgilendirme Formu" lastUpdated="01.05.2026">
      <h2>1. Satıcı Bilgileri</h2>
      <ul>
        <li><strong>Unvan:</strong> {COMPANY.legalName}</li>
        <li><strong>Adres:</strong> {formatAddress()}</li>
        <li><strong>Telefon:</strong> {COMPANY.phone}</li>
        
      </ul>

      <h2>2. Sözleşme Konusu Ürün/Hizmetin Temel Özellikleri</h2>
      <p>
        Sözleşme konusu ürün/hizmetlerin (etkinlik bileti, üyelik paketi, içecek kuponu vb.)
        adı, türü, niteliği, miktarı ve KDV dahil satış fiyatı, sipariş aşamasında ALICI'ya
        Site üzerinde açıkça gösterilir. Belirtilen fiyatlar tüm vergiler dahildir.
      </p>

      <h2>3. Ödeme Bilgileri</h2>
      <p>
        Ödeme, sipariş anında Site üzerinden seçilen ödeme yöntemiyle (kredi/banka kartı veya
        sistemde tanımlı diğer yöntemler) gerçekleştirilir. Tüm ödeme işlemleri SSL ile
        şifrelenmiş güvenli kanallar üzerinden yapılır. SATICI, ALICI'nın kart bilgilerini
        saklamaz.
      </p>

      <h2>4. Teslimat</h2>
      <p>
        Satın alınan etkinlik biletleri, üyelikler ve içecek kuponları <strong>dijital olarak
        anında</strong> ALICI'nın hesabına tanımlanır. ALICI ilgili ürünlere "Biletlerim" ve
        "Kuponlarım" sayfalarından QR kodlu olarak erişebilir. Fiziksel teslimat söz konusu
        değildir; teslimat ücreti alınmaz.
      </p>

      <h2>5. Cayma Hakkı</h2>
      <p>
        6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği'nin
        15. maddesi uyarınca, <strong>belirli bir tarihte veya dönemde yapılması gereken
        eğlence sektörüne ilişkin hizmetlere</strong> yönelik sözleşmelerde cayma hakkı
        bulunmamaktadır. Bu kapsamda satın alınan etkinlik biletleri, üyelikler ve içecek
        kuponları için cayma hakkı kullanılamaz.
      </p>

      <h2>6. İade ve İptal Koşulları</h2>
      <p>
        Etkinliğin SATICI tarafından iptal edilmesi durumunda ödenen tutar, ödeme yapılan
        kanala 14 iş günü içinde iade edilir. ALICI kaynaklı iptal taleplerinde iade
        yapılmaz. Detaylar için <a href="/yasal/iade-iptal">İade & İptal Politikası</a> sayfasına bakınız.
      </p>

      <h2>7. Şikayet ve İtiraz Mercileri</h2>
      <p>
        Bakanlıkça her yıl belirlenen parasal sınırlar dahilinde ALICI'nın yerleşim yerindeki
        veya tüketici işleminin yapıldığı yerdeki Tüketici Hakem Heyetlerine veya Tüketici
        Mahkemelerine başvurulabilir.
      </p>

      <h2>8. Onay</h2>
      <p>
        ALICI, sipariş vermeden önce işbu Ön Bilgilendirme Formu'nu okuyup anladığını ve
        elektronik ortamda gerekli teyidi verdiğini kabul, beyan ve taahhüt eder.
      </p>
    </LegalPageLayout>
  );
}
